module.exports = __webpack_public_path__ + "static/media/44444.f386053d.jpg";